const formatter = new Intl.NumberFormat('en-US', {
  currency: 'USD',
  minimumFractionDigits: 2,
  style: 'currency',
})

export interface FormatDollarsOptions {
  /**
   * Indicates whether the formatted price text should be `'-'` or `'$0.00'` based on the empty price value.
   * If true, it will return `'$0.00'`,
   * otherwise, it will return `'-'`.
   */
  zeroPrice?: boolean
}

// Note: Amount should be provided in dollars (unlike formatPrice, which takes cents) -
// use this for values already stored/computed in dollars (e.g. netPaid, chargeAmount,
// refundAmount). Rounds via Intl.NumberFormat, so float residue like 2.1100000000000003
// formats as $2.11 instead of leaking through.
export const formatDollars = (
  dollars?: number | string | null,
  options: FormatDollarsOptions = {},
) => {
  const { zeroPrice = false } = options

  let amountToFormat: number = typeof dollars === 'string' ? parseFloat(dollars) : (dollars ?? NaN)
  if (!Number.isFinite(amountToFormat)) amountToFormat = 0

  if (!zeroPrice && !amountToFormat) return '-'

  return formatter.format(amountToFormat)
}
